import {Component} from 'react';
import './Tooltip.scss';
import IconPadlock from './IconPadlock';

const Tooltip = function (props) {
	return (
		<span className="tooltip">
			<IconPadlock />
			{props.text}
		</span>
	)
}

export default Tooltip;